"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTokenPriceGroupedLive = void 0;
const Config_1 = require("../../Config");
const GetByIdGroupedLive_1 = require("./GetByIdGroupedLive");
const common_1 = require("./common");
class GetTokenPriceGroupedLive extends GetByIdGroupedLive_1.GetByIdGroupedLive {
    constructor() {
        super(...arguments);
        this.createUrl = () => {
            const requests = this.requests.splice(0, common_1.BATCH_MAX_SIZE);
            const params = { token: requests.map((r) => r.uid) };
            const url = (0, Config_1.getTokenPriceUrl)(this.env);
            return { requests, url, params };
        };
    }
}
exports.GetTokenPriceGroupedLive = GetTokenPriceGroupedLive;
